// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".system-message[data-v-874c3786] {\n  width: 8rem;\n  height: 0.53333rem;\n  margin-right: 0.53333rem;\n}\n.system-message .message-item[data-v-874c3786] {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 0.53333rem;\n  cursor: pointer;\n  text-align: right;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
